module.exports = __webpack_public_path__ + "static/media/up-arrow-svgrepo-com (4).95ab13ed.svg";